import type { Color } from "@/abc-dsk/options";
import { LANGUAGE_GROUP_ENGLISH, LANGUAGE_GROUP_GERMAN } from "@/common/language-groups";

export const VOCAB_LANGUAGE_GROUPS = [LANGUAGE_GROUP_ENGLISH, LANGUAGE_GROUP_GERMAN] as const;

export type VocabLanguageGroup = (typeof VOCAB_LANGUAGE_GROUPS)[number];

export enum ClassQuizStateEnum {
  Lobby = "lobby",
  Prompting = "prompting",
  Answers = "answers",
  Ranking = "ranking",
  Ended = "ended",
  Stats = "stats"
}

type ClassQuizQuestion = {
  id: number;
  type: string;
  lemma: string;
  translation: string;
  answer: string;
  option: string;
  maxDuration: number;
  options: string[];
  createdAt: string;
  startedAt: string | null;
  endedAt: string | null;
};

export type ClassQuizPlayer = {
  name: string;
  correctAnswers: string | null;
  joinedAt: string;
  lastPingAt: string;
};

export type ClassQuiz = {
  code: string;
  listName: string;
  state: ClassQuizStateEnum;
  players: ClassQuizPlayer[];
  topPlayers: ClassQuizPlayer[];
  createdAt: string;
  startedAt: string;
  endedAt: string | null;
  question: ClassQuizQuestion;
  hasAdditionalQuestions: boolean | null;
  answer: string | null;
  userAnswer: string | null;
  totalAnswerCount: number | null;
};

export type Wordclass = {
  english: string;
  short: string;
};

export type Word = {
  id: number;
  lemma: string;
  lemmaWordclass: Wordclass;
  translation: string;
  translationWordclass: Wordclass;
  lemmaPronunciationFileUrl: string;
  openedAt: string | null;
};

export enum WordListType {
  Public = "public",
  Private = "private"
}

export type WordList = {
  shareCode: string;
  type: WordListType;
  name: string;
  authorId: number;
  currentClassQuiz: ClassQuiz | null;
  words: Word[];
};

export type Badge = {
  name: string;
  createdAt: string;
  openedAt: string | null;
};

export type OpenedBadge = Badge & {
  openedAt: string;
};

export type UnpackedBadge = Badge & {
  displayName: string;
  color: Color;
};

export type UnpackedOpenedBadge = UnpackedBadge & OpenedBadge;

export enum AchievementType {
  Normal = "normal",
  Campaign = "campaign"
}

export type Achievement = {
  index: number;
  slug: string;
  title: string;
  description: string;
  badge: Badge | null;
  color: Color;
  type: AchievementType;
  tags: string[];
  progress: number;
  steps: number;
  achievedAt: string | null;
};

export type UnopenedAchievement = Achievement & {
  achievedAt: string;
};

export type OpenedAchievement = UnopenedAchievement & {
  badge: Badge;
};

export enum AchievementItemEffectType {
  TwinklingStarsBlurple = "twinkling-stars-blurple",
  TwinklingStarsGold = "twinkling-stars-gold"
}
